import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CrownIcon, SearchXIcon, LockIcon, GlobeIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
const icons = [<CrownIcon className="w-6 h-6" data-id="element-806" data-mp="2w9zpzur9fzg1" />, <SearchXIcon className="w-6 h-6" data-id="element-807" data-mp="2w9rf28ep747h" />, <LockIcon className="w-6 h-6" data-id="element-808" data-mp="2w8omlw1q8tpg" />, <GlobeIcon className="w-6 h-6" data-id="element-809" data-mp="3ayngvnq5vkzn" />];
const styles = [{
  bg: 'from-primary-100 to-primary-50',
  color: 'text-primary-600'
}, {
  bg: 'from-amber-100 to-amber-50',
  color: 'text-amber-600'
}, {
  bg: 'from-violet-100 to-violet-50',
  color: 'text-violet-600'
}, {
  bg: 'from-emerald-100 to-emerald-50',
  color: 'text-emerald-600'
}];
export function ClassicScenarios() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="relative py-20 lg:py-28 bg-navy-50/50 overflow-hidden" data-id="element-810" data-mp="1koaspueji9p1">
      <div className="absolute inset-0 pointer-events-none" data-id="element-811" data-mp="1pn6flj38u0rt">
        <div className="absolute top-0 right-0 w-[400px] h-[400px] rounded-full bg-primary-100/20 blur-3xl hidden sm:block" data-id="element-812" data-mp="1ukoqvg4qgs2z" />
        <div className="absolute bottom-0 left-1/4 w-[300px] h-[300px] rounded-full bg-cyan-100/15 blur-3xl hidden sm:block" data-id="element-813" data-mp="1zj013ryxx4lq" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref} data-id="element-814" data-mp="24cuksvejpjkt">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-14 lg:mb-16" data-id="element-815" data-mp="28epilpx9petu">
          <span className="text-sm font-semibold text-primary-600 tracking-wide uppercase" data-id="element-816" data-mp="2n9c7uzig8vaq">
            {lang === 'EN' ? 'When you need us' : 'Коли ми потрібні'}
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy-900 tracking-tight max-w-4xl mx-auto" data-id="element-817" data-mp="nyul9ljm3vy3">
            {c.scenarios.title}
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-5 lg:gap-6" data-id="element-818" data-mp="kwzn0msk58qj">
          {c.scenarios.items.map((item, i) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1 + i * 0.08
        }} className="flex gap-4 sm:gap-5 p-6 lg:p-7 rounded-2xl bg-white border border-navy-200 shadow-sm" data-id="element-819" data-mp="ut2wkdpqo9ni" data-mpi={i}>
              <div className={`flex-shrink-0 inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br ${styles[i].bg} ${styles[i].color}`} data-id="element-820" data-mp="ytwhqzbsracp">
                {icons[i]}
              </div>
              <div data-id="element-821" data-mp="18mtyazx8ap8o">
                <div className="flex items-baseline gap-2.5" data-id="element-822" data-mp="1mjqw5lbrl6z2">
                  <span className="text-xs font-bold tabular-nums text-primary-500" data-id="element-823" data-mp="1mi62rz16ru2s">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <h3 className="text-lg font-bold text-navy-900 leading-snug" data-id="element-824" data-mp="2180mb1p7miy1">
                    {item.title}
                  </h3>
                </div>
                <p className="mt-2.5 text-[0.9375rem] text-navy-500 leading-relaxed" data-id="element-825" data-mp="1s69k46tvou8x">
                  {item.text}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}